import React from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {Controller, useForm} from 'react-hook-form'
import {yupResolver} from '@hookform/resolvers/yup'

import {ModalContext} from 'context/ModalContext'
import {getUsers} from 'modules/users/action/actionCreators'
import SelectOptions from 'components/SelectOptions'
import Button from 'components/Button'
import Loader from 'components/Loader'
import { agentValidationRules } from '../yup/agentValidationRules'

const AgentForm = ({onSubmitHandler, initialValues, loading}) => {
  const {hideModal} = React.useContext(ModalContext)
  const dispatch = useDispatch()
  const users = useSelector(({users}) => users.data)

  React.useEffect(() => {
    dispatch(getUsers(1, 25, '-created_at', 'filter[role]=Sales Agent'))
  }, [dispatch])

  const getAgentsOptions = () => {
    return users && users.map((user) => ({value: user.id, label: user.name}))
  }

  // useForm setup
  const {
    handleSubmit,
    control,
    formState: {errors},
    setError,
  } = useForm({
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    resolver: yupResolver(agentValidationRules),
    defaultValues: {...initialValues},
  })

  const onSubmit = (values) => onSubmitHandler(values, setError)

  return (
    <form className='form w-100' onSubmit={handleSubmit(onSubmit)} noValidate>
      <Controller
        {...{
          control,
          name: 'members',
          render: ({field}) => (
            <SelectOptions
              placeholder='Agent'
              containerClassName='mt-7'
              options={getAgentsOptions()}
              id='members'
              isMulti
              {...field}
              error={errors.members}
            />
          ),
        }}
      />
      <div className='d-flex align-items-start justify-content-center gap-5'>
        <Button
          title='Cancel'
          className='btn btn-light btn-active-light-primary py-5'
          onClick={hideModal}
        />
        <Button type='submit' title={loading ? <Loader /> : 'Save'} className='bg-primary py-5' />
      </div>
    </form>
  )
}

export default AgentForm
